import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setSearchDialog, updateUserData } from '../actions';
import { Searchbar } from 'react-native-paper';

class BlockSearch extends Component {
  _showDialog = () => {
    const { block } = this.props;

    this.props.dispatch(setSearchDialog({ block }));
  }
  cancel = () => {
    const { block } = this.props;
    this.props.dispatch(updateUserData(block.name, []));
  }

  render() {
    const { block } = this.props;
    return (
      <Searchbar
        style={{ width: "90%" }}
        value={block.label || ""}
        // onPress={this._showDialog}
        onFocus={this._showDialog}
        autoCorrect={false}
        onChangeText={this.cancel}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    searchDialog: state.searchDialog
  };
}

BlockSearch.propTypes = {
  dispatch: PropTypes.func.isRequired,
  block: PropTypes.object,
  onChange: PropTypes.func
};

export default connect(mapStateToProps)(BlockSearch);
